// extracted by mini-css-extract-plugin
export default {"error":"lib-component-mappings-sky-parallax-components-Form-Error-styles-module__error--OOwJp"};